exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:icofont;src:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.eot\");src:url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.eot#iefix\") format(\"embedded-opentype\"),url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.ttf\") format(\"truetype\"),url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.woff\") format(\"woff\"),url(\"/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/fonts/icofont.svg#icofont\") format(\"svg\");font-weight:400;font-style:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de4d5f42","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 232
// module chunks = 0